// Platform hostname assignments:
//   ordrs.ai / www.ordrs.ai       public marketing site
//   merchant.ordrs.ai             merchant account launcher
//   provider.ordrs.ai             service-provider account launcher
//   autoaccount.ordrs.ai          auto repair account launcher
//   account.ordrs.ai              legacy alias for autoaccount.ordrs.ai
//   auto.ordrs.ai                 autonomous auto vertical marketing site
// Custom merchant-owned domains (e.g. orders.joesbakery.com) are storefront-only
// and are resolved separately in App.js — they are not part of this list.
export const AUTO_ACCOUNT_HOSTS = ["autoaccount.ordrs.ai", "account.ordrs.ai"];
export const MERCHANT_HOSTS = ["merchant.ordrs.ai"];
export const PROVIDER_HOSTS = ["provider.ordrs.ai"];
export const AUTO_HOSTS = ["auto.ordrs.ai"];
export const PLATFORM_HOSTS = [
  "ordrs.ai", "www.ordrs.ai", "localhost", "127.0.0.1",
  ...AUTO_ACCOUNT_HOSTS,
  ...MERCHANT_HOSTS,
  ...PROVIDER_HOSTS,
  ...AUTO_HOSTS,
];

const hostname = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
export const isAutoAccountHost = AUTO_ACCOUNT_HOSTS.includes(hostname);
export const isMerchantHost = MERCHANT_HOSTS.includes(hostname);
export const isProviderHost = PROVIDER_HOSTS.includes(hostname);
export const isAutoHost = AUTO_HOSTS.includes(hostname);
export const isCustomDomain = !PLATFORM_HOSTS.includes(hostname)
  && !hostname.endsWith(".ordrs.ai")
  && !hostname.endsWith(".vercel.app");
